import React, { useEffect, useState } from "react";
import "./orderInDetails.scss";
import {
  Backdrop,
  Button,
  CircularProgress,
  Divider,
  Grid,
  Skeleton,
  Stack,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import dateformat from "dateformat";

import OrderStatusButton from "../../../components/orderStatusButton/OrderStatusButton";
import TimelineDeliveryStatus from "../../../components/timelineDeliveryStatus/TimelineDeliveryStatus";
import paymentStore from "../../../stores/paymentStore";
import orderStore from "../../../stores/orderStore";
import usersStore from "../../../stores/usersStore";
import productStore from "../../../stores/productStore";
import couponStore from "../../../stores/couponStore";
import brandStore from "../../../stores/brandStore";

import orderDeliveryStatusTimeStore from "../../../stores/orderDeliveryStatusTimeStore";
import addressStore from "../../../stores/addressStore";
import ProductDetailsSkeleton from "./orderInDetailsSkeleton/ProductDetailsSkeleton";
import OrderHistoryTimeLineSkeleton from "./orderInDetailsSkeleton/OrderHistoryTimeLineSkeleton";
import CustomerInfoSkeleton from "./orderInDetailsSkeleton/CustomerInfoSkeleton";
import ShippingInfoSkeleton from "./orderInDetailsSkeleton/ShippingInfoSkeleton";
import { PRODUCT_IMAGE_URL } from "../../../constant";

// Icons
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import CurrencyRupeeRoundedIcon from "@mui/icons-material/CurrencyRupeeRounded";

import { jsPDF } from "jspdf";
import { YsabeauOffice } from "../../../assets/font/Fonts";
import sidebarActivePage from "../../../stores/sidebarActivePage";
import orderReturnRequestStore from "../../../stores/orderReturnRequestStore";
import { LoadingButton } from "@mui/lab";

const OrderInDetails = () => {
  const navigate = useNavigate();
  const param = useParams();
  const PaymentStore = paymentStore();
  const OrderStore = orderStore();
  const UsersStore = usersStore();
  const ProductStore = productStore();
  const CouponStore = couponStore();
  const AddressStore = addressStore();
  const OrderDeliveryStatusTimeStore = orderDeliveryStatusTimeStore();
  const BrandStore = brandStore();
  const OrderReturnRequestStore = orderReturnRequestStore();

  const [orderDetails, setOrderDetails] = useState(null);

  const [statusBackgroundColor, setStatusBackgroundColor] = useState(null);
  const [statusColor, setStatusColor] = useState(null);
  const [deliveryStatus, setDeliveryStatus] = useState();

  const [backdropLoading, setBackdropLoading] = useState(false);

  const SidebarActivePage = sidebarActivePage();
  useEffect(() => {
    SidebarActivePage.setIsActive({ setPage: "Orders" });
    window.scrollTo({ top: 0 });
  }, []);

  useEffect(() => {
    if (
      !PaymentStore.isLoading &&
      !OrderStore.isLoading &&
      !UsersStore.isLoading &&
      !ProductStore.isLoading &&
      !CouponStore.isLoading &&
      !OrderDeliveryStatusTimeStore.isLoading &&
      !AddressStore.isLoading &&
      !OrderReturnRequestStore.isLoading
    ) {
      init();
    }
  }, [
    PaymentStore.isLoading,
    OrderStore.isLoading,
    UsersStore.isLoading,
    ProductStore.isLoading,
    CouponStore.isLoading,
    OrderDeliveryStatusTimeStore.isLoading,
    AddressStore.isLoading,
    OrderReturnRequestStore.isLoading,
  ]);

  const init = () => {
    for (let i = 0; i < PaymentStore.mPaymentDetails.length; i++) {
      if (PaymentStore.mPaymentDetails[i]._id === param.paymentID) {
        // order find
        const oProduct = [];
        let history = "";
        let returnProduct = [];
        for (let o = 0; o < OrderStore.orderDetail.length; o++) {
          if (
            OrderStore.orderDetail[o].paymentID ===
            PaymentStore.mPaymentDetails[i]._id
          ) {
            for (let p = 0; p < ProductStore.mProduct.length; p++) {
              if (
                ProductStore.mProduct[p]._id ===
                OrderStore.orderDetail[o].productID
              ) {
                oProduct.push({
                  _id: OrderStore.orderDetail[o]._id,
                  productImage: ProductStore.mProduct[p].productImages[0],
                  productName: ProductStore.mProduct[p].productName,
                  qty: OrderStore.orderDetail[o].quantity,
                  price: OrderStore.orderDetail[o].purchasePrice,
                  regularPrice: ProductStore.mProduct[p].regularPrice,
                  discountPricePer:
                    ProductStore.mProduct[p].regularPrice -
                    OrderStore.orderDetail[o].purchasePrice,
                  size: OrderStore.orderDetail[o].selectedSize,
                  color: OrderStore.orderDetail[o].selectedColor?.toString(),
                });
              }
            }
            // orderDeliveryStatusTime
            for (
              let d = 0;
              d < OrderDeliveryStatusTimeStore.orderDeliveryStatusTime.length;
              d++
            ) {
              if (
                OrderDeliveryStatusTimeStore.orderDeliveryStatusTime[d]._id ===
                OrderStore.orderDetail[o].orderDeliveryStatusTimeID
              ) {
                history =
                  OrderDeliveryStatusTimeStore.orderDeliveryStatusTime[d];
              }
            }

            // is return order
            if (OrderReturnRequestStore.orderReturnRequest) {
              for (
                let ro = 0;
                ro < OrderReturnRequestStore.orderReturnRequest.length;
                ro++
              ) {
                if (
                  OrderReturnRequestStore.orderReturnRequest[ro].orderID ===
                  OrderStore.orderDetail[o]._id
                ) {
                  returnProduct.push(
                    OrderReturnRequestStore.orderReturnRequest[ro]
                  );
                }
              }
            }

            setDeliveryStatus(OrderStore.orderDetail[o].order_delivery_status);
            if (OrderStore.orderDetail[o].order_delivery_status === "Pending") {
              setStatusColor("#E4A11B");
              setStatusBackgroundColor("rgba(240, 172, 78,  0.200)");
            } else if (
              OrderStore.orderDetail[o].order_delivery_status === "Preparing"
            ) {
              setStatusColor("#9FA6B2");
              setStatusBackgroundColor("rgba(159, 166, 178,  0.200)");
            } else if (
              OrderStore.orderDetail[o].order_delivery_status ===
              "Out Of Delivery"
            ) {
              setStatusColor("#54B4D3");
              setStatusBackgroundColor("rgba(84, 180, 211,  0.200)");
            } else if (
              OrderStore.orderDetail[o].order_delivery_status === "Delivered"
            ) {
              setStatusColor("#14A44D");
              setStatusBackgroundColor("rgba(20, 164, 77,  0.200)");
            } else if (
              OrderStore.orderDetail[o].order_delivery_status === "Return"
            ) {
              setStatusColor("#DC4C64");
              setStatusBackgroundColor("rgba(220, 76, 100,  0.200)");
            }
          }
        }
        // PaymentStore.mPaymentDetails[i].couponID,
        let couponName = "";
        let discountPercentage = 0;
        if (PaymentStore.mPaymentDetails[i].couponID) {
          for (let c = 0; c < CouponStore.coupon.length; c++) {
            if (
              CouponStore.coupon[c]._id ===
              PaymentStore.mPaymentDetails[i].couponID
            ) {
              couponName = CouponStore.coupon[c].couponName;
              discountPercentage = CouponStore.coupon[c].discount;
            }
          }
        }

        // PaymentStore.mPaymentDetails[i].addressID,
        let shippingAddress = "";
        for (let a = 0; a < AddressStore.userAddress.length; a++) {
          if (
            PaymentStore.mPaymentDetails[i].addressID ===
            AddressStore.userAddress[a]._id
          ) {
            shippingAddress = AddressStore.userAddress[a];
          }
        }

        // PaymentStore.mPaymentDetails[i].userID,
        let customer = "";
        for (let u = 0; u < UsersStore.allUser.length; u++) {
          if (
            PaymentStore.mPaymentDetails[i].userID === UsersStore.allUser[u]._id
          ) {
            customer = UsersStore.allUser[u];
          }
        }

        setOrderDetails({
          _id: param.paymentID,
          payment_at: PaymentStore.mPaymentDetails[i].payment_at,
          subTotal: PaymentStore.mPaymentDetails[i].subTotal,
          discount: PaymentStore.mPaymentDetails[i].discount,
          couponDiscount: PaymentStore.mPaymentDetails[i].couponDiscount,
          total: PaymentStore.mPaymentDetails[i].total,
          paymentType: PaymentStore.mPaymentDetails[i].paymentType,
          razorpay_order_id: PaymentStore.mPaymentDetails[i].razorpay_order_id,
          razorpay_payment_id:
            PaymentStore.mPaymentDetails[i].razorpay_payment_id,
          razorpay_signature:
            PaymentStore.mPaymentDetails[i].razorpay_signature,
          couponID: PaymentStore.mPaymentDetails[i].couponID,
          addressID: PaymentStore.mPaymentDetails[i].addressID,
          userID: PaymentStore.mPaymentDetails[i].userID,
          oProduct,
          history,
          couponName,
          discountPercentage,
          shippingAddress,
          customer,
          returnProduct,
        });
      }
    }
  };

  const DownloadBill = () => {
    const doc = new jsPDF();

    doc.addFileToVFS("YsabeauOffice-Thin-normal.ttf", YsabeauOffice);
    doc.addFont(
      "YsabeauOffice-Thin-normal.ttf",
      "YsabeauOffice",
      "normal",
      200
    );

    doc.addFileToVFS("YsabeauOffice-VariableFont_wght-bold.ttf", YsabeauOffice);
    doc.addFont(
      "YsabeauOffice-VariableFont_wght-bold.ttf",
      "YsabeauOffice",
      "bold"
    );

    doc.setFont("YsabeauOffice", "bold");
    doc.setFontSize(30);
    doc.text(`${BrandStore.brand.brandName}`, 10, 30);

    doc.setFontSize(12);
    doc.setTextColor(100);
    doc.setFont("YsabeauOffice", "normal");
    doc.text("Bill of Supply / Cash Memo", 200, 20, null, null, "right");
    doc.text("(Original for Recipient)", 200, 25, null, null, "right");

    doc.setTextColor(0);
    doc.setFont("YsabeauOffice", "bold");
    doc.text(
      `Bill Date: ${dateformat(
        new Date(orderDetails.payment_at),
        "dd mmm yyyy"
      )}`,
      200,
      35,
      null,
      null,
      "right"
    );

    doc.setFont("YsabeauOffice", "normal");

    doc.setTextColor(100);
    doc.setFontSize(9);
    doc.text("Price In INR", 200, 45, null, null, "right");

    doc.setFontSize(12);
    doc.setDrawColor(150);
    doc.setLineWidth(0.2);
    doc.line(0, 50, 220, 50);

    doc.setTextColor(0);
    doc.setFont("YsabeauOffice", "bold");
    doc.text("Our Address", 10, 65);

    doc.setFont("YsabeauOffice", "normal");
    doc.setTextColor(100);
    doc.text(`${BrandStore.brand.brandName}`, 10, 72);
    doc.text(`${BrandStore.brand.brandAddress}`, 10, 77);
    doc.text(`${BrandStore.brand.brandContactUs}`, 10, 82);

    doc.setFont("YsabeauOffice", "bold");
    doc.setTextColor(0);
    doc.text("Shipping Address", 200, 65, null, null, "right");

    doc.setFont("YsabeauOffice", "normal");
    doc.setTextColor(100);
    doc.text(
      `${orderDetails.shippingAddress.fullName}`,
      200,
      72,
      null,
      null,
      "right"
    );
    doc.text(
      `${orderDetails.shippingAddress.address}`,
      200,
      77,
      null,
      null,
      "right"
    );
    doc.text(
      `${orderDetails.shippingAddress.city}, ${orderDetails.shippingAddress.state} - ${orderDetails.shippingAddress.pincode}`,
      200,
      82,
      null,
      null,
      "right"
    );
    doc.text(
      `${orderDetails.shippingAddress.phoneNumber}`,
      200,
      87,
      null,
      null,
      "right"
    );

    doc.setLineWidth(0.1);
    doc.line(10, 100, 200, 100);
    doc.setTextColor(0);
    doc.setFont("YsabeauOffice", "bold");

    doc.text("S.No", 20, 106, { maxWidth: 10 });
    doc.text("Item", 40, 106, { maxWidth: 80 });
    doc.text("QTY", 130, 106, { maxWidth: 10 });
    doc.text("Price", 150, 106, { maxWidth: 20 });
    doc.text("Amount", 180, 106, { maxWidth: 20 });

    doc.setLineWidth(0.1);
    doc.line(10, 110, 200, 110);

    doc.setTextColor(100);
    doc.setFont("YsabeauOffice", "normal");

    var line = 117;
    for (var i = 0; i < orderDetails.oProduct.length; i += 1) {
      let sno = i + 1;
      doc.text(`${sno}`, 20, line, { maxWidth: 10 });
      doc.text(`${orderDetails.oProduct[i].productName}`, 40, line, {
        maxWidth: 80,
      });
      doc.text(`${orderDetails.oProduct[i].qty}`, 130, line, { maxWidth: 10 });
      doc.text(`${orderDetails.oProduct[i].price}`, 150, line, {
        maxWidth: 20,
      });
      doc.text(
        `${orderDetails.oProduct[i].qty * orderDetails.oProduct[i].price}`,
        180,
        line,
        { maxWidth: 20 }
      );
      line = line + 6;
    }

    line = line + 10;
    doc.text("Subtotal", 170, line, null, null, "right");
    doc.text(` ${orderDetails.subTotal}`, 195, line, null, null, "right");

    line = line + 5;
    doc.text("Discount", 170, line, null, null, "right");
    doc.text(`${orderDetails.discount}`, 195, line, null, null, "right");

    if (orderDetails.couponDiscount !== 0) {
      line = line + 5;
      doc.text("Coupon Discount", 170, line, null, null, "right");
      doc.text(
        `${orderDetails.couponDiscount}`,
        195,
        line,
        null,
        null,
        "right"
      );
    }

    line = line + 5;
    doc.text("Shipping", 170, line, null, null, "right");
    doc.text("Free", 195, line, null, null, "right");

    doc.setFont("YsabeauOffice", "bold");
    doc.setFontSize(15);
    doc.setTextColor(0);

    line = line + 10;
    doc.text("Total", 170, line, null, null, "right");
    doc.text(`${orderDetails.total}`, 195, line, null, null, "right");

    doc.setFont("YsabeauOffice", "normal");
    doc.setFontSize(13);

    doc.setLineWidth(0.1);
    doc.line(0, 280, 220, 280);
    doc.text(
      `Thank you for ordering with ${BrandStore.brand.brandName}.`,
      10,
      290
    );

    doc.save("bill.pdf");
  };

  const returnedProduct = async (returnProduct, item) => {
    setBackdropLoading(true);

    const updateSubTotal = orderDetails.subTotal - item.regularPrice;
    const updateDiscount = orderDetails.discount - item.discountPricePer;
    let updateCouponDiscount = 0;
    if (orderDetails.discountPercentage !== 0) {
      updateCouponDiscount =
        orderDetails.couponDiscount -
        (item.price * orderDetails.discountPercentage) / 100;
    }
    const updateTotal = updateSubTotal - updateDiscount - updateCouponDiscount;

    const paymentID = param.paymentID;
    const updatePaymentData = {
      subTotal: updateSubTotal,
      discount: updateDiscount,
      couponDiscount: updateCouponDiscount,
      total: updateTotal,
    };

    const createSubTotal = item.regularPrice;
    const createDiscount = item.discountPricePer;
    let createCouponDiscount = 0;
    if (orderDetails.discountPercentage !== 0) {
      createCouponDiscount =
        (createSubTotal * orderDetails.discountPercentage) / 100;
    }
    const createTotal = createSubTotal - createDiscount - createCouponDiscount;

    const createPaymentData = {
      subTotal: createSubTotal,
      discount: createDiscount,
      couponDiscount: createCouponDiscount,
      total: createTotal,
      paymentType: orderDetails.paymentType,
      couponID: orderDetails.couponID,
      addressID: orderDetails.addressID,
      userID: orderDetails.userID,
      razorpay_order_id: orderDetails.razorpay_order_id,
      razorpay_payment_id: orderDetails.razorpay_payment_id,
      razorpay_signature: orderDetails.razorpay_signature,
      payment_at: orderDetails.payment_at,
    };

    const createOrderDeliveryStatusTimeData = {
      pending: orderDetails.history.pending,
      preparing: orderDetails.history.preparing,
      in_transit: orderDetails.history.in_transit,
      out_of_delivery: orderDetails.history.out_of_delivery,
      delivered: orderDetails.history.delivered,
      userID: orderDetails.history.userID,
    };

    // call api and get paymentID and orderDeliveryStatusTimeID
    const newPaymentID = await PaymentStore.createAndUpdatePaymentForReturn({
      createPaymentData,
      updatePaymentData,
      paymentID,
    });

    const newOrderDeliveryStatusTimeID =
      await OrderDeliveryStatusTimeStore.createOrderDeliveryStatusTimeForReturn(
        { createOrderDeliveryStatusTimeData }
      );

    await OrderStore.updateOrderDeliveryStatusTimeIDForReturn({
      _id: returnProduct.orderID,
      paymentID: newPaymentID,
      orderDeliveryStatusTimeID: newOrderDeliveryStatusTimeID,
    });

    await OrderReturnRequestStore.updateReturningStatus({
      id: returnProduct._id,
      order_returning_status: false,
      paymentID: newPaymentID,
    });

    setBackdropLoading(false);
  };

  return (
    <div className="order-in-details">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backdropLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Stack className="transition">
        <Grid container spacing={2} className="order-in-details-head">
          <Grid item lg={8} md={8} sm={12} xs={12}>
            <div className="left-side-head">
              <div className="back-button" onClick={() => navigate(-1)}>
                <ArrowBackIosRoundedIcon />
              </div>
              <div className="order-id-and-time">
                <div className="order-id-status">
                  <h2 className="order-id">Order #{param.paymentID}</h2>
                  {orderDetails ? (
                    <div
                      className="order-status"
                      style={{
                        background: statusBackgroundColor,
                        color: statusColor,
                      }}
                    >
                      {deliveryStatus}
                    </div>
                  ) : (
                    <Skeleton animation="wave" width={50} component="div" />
                  )}
                </div>
                {orderDetails ? (
                  <div className="date-time">
                    {dateformat(
                      new Date(orderDetails.payment_at),
                      "dd mmm yyyy hh:MM TT"
                    )}
                  </div>
                ) : (
                  <Skeleton animation="wave" width={150} component="div" />
                )}
              </div>
            </div>
          </Grid>
          <Grid item lg={4} md={4} sm={12} xs={12}>
            <div className="right-side-head">
              {orderDetails ? (
                <Stack spacing={2} direction="row">
                  <OrderStatusButton
                    buttonName={deliveryStatus}
                    paymentID={param.paymentID}
                    history={orderDetails.history}
                    returnProduct={orderDetails.returnProduct}
                    productLength={orderDetails.oProduct.length}
                  />
                  {/* <Button
                    variant="outlined"
                    style={{
                      color: "#000",
                      borderColor: "#000",
                      fontWeight: 700,
                      fontSize: "12px",
                    }}
                    onClick={() =>
                      window.open(
                        `${window.location.origin}/orders/${param.paymentID}/invoice`
                      )
                    }
                  >
                    <p>View Invoice</p>
                  </Button> */}
                  <Button
                    variant="outlined"
                    style={{
                      color: "#000",
                      borderColor: "#000",
                      fontWeight: 700,
                      fontSize: "12px",
                    }}
                    onClick={DownloadBill}
                  >
                    <p>Download Bill</p>
                  </Button>
                </Stack>
              ) : (
                <Stack spacing={2} direction="row">
                  <Skeleton>
                    <Button>Pending</Button>
                  </Skeleton>
                  <Skeleton>
                    <Button variant="outlined">View Invoice</Button>
                  </Skeleton>
                </Stack>
              )}
            </div>
          </Grid>
        </Grid>
        <Grid container className="container" spacing={2}>
          <Grid container item lg={8} md={8} sm={12} xs={12}>
            {orderDetails ? (
              <div className="order-product-details">
                <Grid container>
                  <Grid item xs={12} className="title">
                    Details
                  </Grid>

                  {orderDetails.oProduct.map((item) => (
                    <Grid
                      container
                      item
                      className="single-product"
                      key={item._id}
                    >
                      <Grid item xs={8} sm={8}>
                        <div className="product-basic-details">
                          <div className="product-img">
                            <img
                              src={`${PRODUCT_IMAGE_URL}${item.productImage}`}
                              alt="product-image"
                            />
                          </div>
                          <div className="product-name-size-color">
                            <div className="product-name">
                              {item.productName}
                            </div>
                            <div className="product-size">{item.size}</div>
                            <div className="product-color">{item.color}</div>
                          </div>
                        </div>
                      </Grid>
                      <Grid item xs={2} sm={2}>
                        <p className="product-qty">x{item.qty}</p>
                      </Grid>
                      <Grid item xs={2} sm={2}>
                        <p className="product-price">₹{item.price}</p>
                      </Grid>
                      {orderDetails.returnProduct.length !== 0 &&
                        orderDetails.returnProduct.map((returnProduct) => {
                          if (
                            returnProduct.orderID === item._id &&
                            returnProduct.order_returning_status &&
                            orderDetails.oProduct.length !==
                              orderDetails.returnProduct.length
                          ) {
                            return (
                              <Grid item xs={12} key={returnProduct._id}>
                                <div className="return-btn">
                                  <LoadingButton
                                    className="btn"
                                    variant="contained"
                                    onClick={() =>
                                      returnedProduct(returnProduct, item)
                                    }
                                  >
                                    Returned
                                  </LoadingButton>
                                </div>
                              </Grid>
                            );
                          }
                        })}
                    </Grid>
                  ))}

                  <Grid item container>
                    <Grid item xs={false} sm={6} md={7} lg={8} />
                    <Grid item xs={12} sm={6} md={5} lg={4}>
                      <div className="pricing">
                        <div className="subtotal item">
                          <div className="label">Subtotal</div>
                          <div className="price">₹{orderDetails.subTotal}</div>
                        </div>
                        <div className="discount item">
                          <div className="label">Discount</div>
                          <div className="price">₹{orderDetails.discount}</div>
                        </div>
                        {orderDetails.couponDiscount !== 0 && (
                          <div className="coupon-discount item">
                            <div className="label">
                              <p>Coupon Discount</p>
                              <p className="coupon-name">
                                - {orderDetails.couponName}
                              </p>
                            </div>
                            <div className="price">
                              ₹{orderDetails.couponDiscount}
                            </div>
                          </div>
                        )}

                        <div className="shipping item">
                          <div className="label">Shipping</div>
                          <div className="price">Free</div>
                        </div>
                        <div className="total item">
                          <div className="label">Total</div>
                          <div className="price">₹{orderDetails.total}</div>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </div>
            ) : (
              <ProductDetailsSkeleton />
            )}

            <div className="timeline">
              <div className="title">History</div>
              {orderDetails ? (
                <TimelineDeliveryStatus history={orderDetails.history} />
              ) : (
                <OrderHistoryTimeLineSkeleton />
              )}
            </div>
          </Grid>
          <Grid item lg={4} md={4} sm={12} xs={12}>
            <div className="order-customer-details">
              <div className="customer-info">
                <div className="title">Customer Info</div>
                {orderDetails ? (
                  <div className="customer-info-content">
                    <Stack spacing={1}>
                      <div className="customer-name">
                        {`${orderDetails.customer.firstName} ${orderDetails.customer.lastName}`}
                      </div>
                      <div className="customer-email">
                        {orderDetails.customer.email}
                      </div>
                      <div className="customer-contact-no">
                        Contact No{" "}
                        <span>{orderDetails.customer.phoneNumber}</span>
                      </div>
                    </Stack>
                  </div>
                ) : (
                  <CustomerInfoSkeleton />
                )}
              </div>
              <Divider sx={{ mt: 1, mb: 1 }} />
              <div className="shipping-info">
                <div className="title">Shipping</div>
                {orderDetails ? (
                  <div className="shipping-info-content">
                    <Stack spacing={1}>
                      <div className="shipping-customer-name">
                        {orderDetails.shippingAddress.fullName}
                      </div>
                      <div className="shipping-customer-contact-no">
                        Contact No{" "}
                        <span>{orderDetails.shippingAddress.phoneNumber}</span>
                      </div>
                      <div className="shipping-address">
                        <div className="title-address">Address</div>
                        <div className="address-content">
                          {orderDetails.shippingAddress.address},{" "}
                          {orderDetails.shippingAddress.city},{" "}
                          {orderDetails.shippingAddress.state} -
                          {orderDetails.shippingAddress.pincode}
                        </div>
                      </div>
                    </Stack>
                  </div>
                ) : (
                  <ShippingInfoSkeleton />
                )}
              </div>
              <Divider sx={{ mt: 1, mb: 1 }} />
              <div className="payment-info">
                <div className="title">Payment</div>
                <div className="payment-info-content">
                  <Stack spacing={1}>
                    <div className="payment-type item">
                      <p>Payment Type </p>
                      <span>
                        {orderDetails ? (
                          orderDetails.paymentType
                        ) : (
                          <Skeleton width={70} height={20} animation="wave" />
                        )}
                      </span>
                    </div>
                    {orderDetails && orderDetails.paymentType === "online" && (
                      <>
                        <div className="razorpay-order-id razorpay-item">
                          <p>Razorpay Order Id </p>
                          <span>{orderDetails.razorpay_order_id}</span>
                        </div>
                        <div className="razorpay-payment-id razorpay-item">
                          <p>Razorpay Payment Id </p>
                          <span>{orderDetails.razorpay_payment_id}</span>
                        </div>
                      </>
                    )}
                  </Stack>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </Stack>
    </div>
  );
};

export default OrderInDetails;
